import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { authActions } from "../../app/store";
import { history } from "../../Helpers/history";
import { AuthService } from "../../services/auth";
import Button from "../components/Button";
import Dialog from "../components/Dialog";
import LoginScreen from "../components/LoginScreen";

const getErrorMessage = (error) => {
  if (typeof error === "string") return error;

  return error?.message
    || error?.data?.message
    || "We could not sign you in. Check your details and try again.";
};

const Login = () => {
  const dispatch = useDispatch();
  const authUser = useSelector((state) => state.auth.user);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPasswordHelp, setShowPasswordHelp] = useState(false);

  useEffect(() => {
    if (authUser) history.navigate("/");
  }, [authUser]);

  const handleSubmit = async ({ username, password }) => {
    if (!username.trim() || !password) {
      setError("Enter your email or username and password.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      await AuthService.sanctumCsrfCookie();

      const result = await dispatch(authActions.login({
        email: username.trim(),
        password,
      }));

      if (authActions.login.rejected.match(result)) {
        setError(getErrorMessage(result.payload));
      }
    } catch (requestError) {
      setError(getErrorMessage(requestError));
    } finally {
      setLoading(false);
    }
  };

  const redirectToPasswordReset = () => {
    window.open(`${process.env.REACT_APP_V4_URL}/users/forgotPassword`, "_blank", "noopener,noreferrer");
    setShowPasswordHelp(false);
  };

  return (
    <>
      <LoginScreen
        error={error}
        loading={loading}
        onForgotPassword={() => setShowPasswordHelp(true)}
        onSubmit={handleSubmit}
      />

      <Dialog
        actions={(
          <>
            <Button onClick={() => setShowPasswordHelp(false)} variant="outline">Cancel</Button>
            <Button onClick={redirectToPasswordReset}>Continue to RailHub</Button>
          </>
        )}
        description="User accounts and passwords for Worksite Manager are managed in RailHub."
        onClose={() => setShowPasswordHelp(false)}
        open={showPasswordHelp}
        size="small"
        title="Forgot your password?"
      >
        <p>You will be taken to RailHub in a new browser tab to reset your password.</p>
      </Dialog>
    </>
  );
};

export default Login;